<template>
  <textbox
    class="readonly"
    :value="value"
    :name="name"
    readonly="readonly"
    required
  />
</template>

<script>
const numberText = [ '1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th' ];

// All textboxes so far are read-only.
export default {
  name: 'ControlAndBedroomTextbox',
  props: {
    name: {
      type: String,
      default: '',
    },
    roomNumber: {
      validator: (prop) => {
        if(typeof prop !== 'number') {
          throw new Error("roomNumber accepts only null or a Number");
        }
        return true;
      },
      required: true,
    },
    propertyType: {
      type: String,
      required: true,
      // validator: (prop) => {
      //   if ([ 'Residential', 'Daycare' ].indexOf(prop) === -1) {
      //     throw new Error("propertyType accepts only ['Residential', 'Daycare']");
      //   }
      //   return true;
      // },
    },
    type: {
      type: String,
      required: true,
      // Textboxes are floor, window, or control
      // validator: (prop) => {
      //   if ([ 'window', 'floor', 'control' ].indexOf(prop) === -1) {
      //     throw new Error("type accepts only [ 'window', 'floor', 'control' ]");
      //   }
      //   return true;
      // },
    },
    location: {
      type: String,
      required: false,
      default: '',
      // validator: (prop) => {
      //   if ([ 'front', 'middle', 'rear', '' ].indexOf(prop) === -1) {
      //     throw new Error("location accepts only [ 'front', 'middle', 'rear', '' ]");
      //   }
      //   return true;
      // },
    },
  },
  computed: {
    // Even though it is read only, I am putting this here just in case. 
    value() {
      if (this.type === 'control') {
        // if (this.roomNumber !== -1) {
        //   throw new Error('Control value accepts only -1 as a roomNumber');
        // }
        return 'Control Sample';
      }

      if (this.propertyType === 'Residential') {
        if (this.type === 'floor' && this.roomNumber === 0) {
          return this.$sprintf('Common area floor');
        }
        if (this.roomNumber > 0) {
          return this.$sprintf('%s bedroom %s (%s)', numberText[(this.roomNumber-1)], this.type, this.location);
        }
      } else {
        if (this.location) {
          throw new Error('Location has to be empty for all common areas');
        }
        return this.$sprintf('%s common area %s', numberText[this.roomNumber], this.type);
      }
      
      return 'ERROR!';
    },
  },
};
</script>

<style lang="scss">
  .input-text {
    .input[readonly],
    .input[readonly="readonly"] {
      &:focus {
        padding-top: 0;
        padding-bottom: 0;
        & + label {
          display: none !important;
        }
      }
    }
  }
</style>